import { useEffect, useState } from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useCheckVerifyCodeMutation, useRegisterMutation, useSendVerifyCodeMutation } from "../../API/authApi";
import { useGeneralHooks, useToastify } from "../../Hooks/hooks";
import { ISignUpFormValues } from "../../Interfaces/formValue-interfaces";
import { SignUpScreens } from "../../Interfaces/componentTypes";
import { ICheckVerifyCode, IRegisterFormValues, ISendVerifyCode } from "../../Interfaces/request-interfaces";
import { ISignUpError } from "../../Interfaces/error.interfaces";

const useSignUpHooks = () => {
    const { t, navigate } = useGeneralHooks();
    const { showToastError } = useToastify();
    const [signUp, { isLoading: signUpLoading, isError: isSignUpError, isSuccess: signUpSuccess, error: signUpError }] = useRegisterMutation();
    const [recieveCode, { isLoading: recieveCodeLoding }] = useSendVerifyCodeMutation();
    const [verifyCode, { isLoading: verifyLoading, isSuccess: verifySuccess, isError: verifyError }] = useCheckVerifyCodeMutation();
    const [screenType, setScreenType] = useState<SignUpScreens>(SignUpScreens.SignUp);
    const { register, control, handleSubmit, formState: { errors }, getValues, setValue, setError } = useForm<ISignUpFormValues>();
    const onSignUp: SubmitHandler<ISignUpFormValues | FieldValues> = (values) => {
        const payload: IRegisterFormValues = {
            user: {
                username: values.username.trim(),
                email: values.email.trim(),
                password: values.password.trim(),
            },
            phone_number: values.phone_number
        };
        signUp(payload)
    };

    const onVerify: SubmitHandler<ISignUpFormValues | FieldValues> = (values) => {
        const payload: ICheckVerifyCode = {
            email: getValues().email.trim(),
            code: values.verifyCode
        };
        verifyCode(payload);
    };

    const handleRecieveCode = () => {
        const email = getValues().email.trim();
        setValue('verifyCode', '');
        const payload: ISendVerifyCode = {
            email: email
        }
        recieveCode(payload)
    };

    useEffect(() => {
        if (signUpSuccess) {
            handleRecieveCode();
            setScreenType(SignUpScreens.Verify);
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else if (isSignUpError) {
            const errorObj: ISignUpError = signUpError as ISignUpError;

            const errors = errorObj?.result?.error;
            if (errors) {
                if (errors.user?.email && errors.user.email.length > 0) {
                    setError("email", {
                        type: "manual",
                        message: t('Errors.Email_Exist'),
                    });
                }

                if (errors.user?.username && errors.user.username.length > 0) {
                    const usernameError = errors.user?.username?.[0];
                    if (usernameError?.includes("Enter a valid username")) {
                        setError("username", {
                            type: "manual",
                            message: t('Errors.Username_Valid'),
                        });
                    } else {
                        setError("username", {
                            type: "manual",
                            message: t('Errors.Username_Exist'),
                        });
                    }
                }

                if (errors.phone_number && errors.phone_number.length > 0) {
                    setError("phone_number", {
                        type: "manual",
                        message: t('Errors.Phone_Exist'),
                    });
                }
            } else {
                // fallback
                showToastError(t('Toast.Error.Common'));
            }
        }
    }, [signUpSuccess, signUpError, isSignUpError]);


    useEffect(() => {
        if (verifySuccess) {
            navigate('/login')
        } else if (verifyError) {
            setError('verifyCode', { message: t('Errors.SMS') })
        }
    }, [verifySuccess, verifyError, navigate]);

    return {
        navigate,
        register,
        handleSubmit,
        onSignUp,
        onVerify,
        handleRecieveCode,
        control,
        errors,
        screenType,
        signUpLoading,
        verifyLoading,
        recieveCodeLoding
    }
};

export default useSignUpHooks